import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TitleText from '../atoms/TitleText';
import { useGetReviewsListQuery } from '../../store/services/Review';
import ReviewBox from './ReviewBox';
import { Pagination } from 'antd';
import { ReviewSkeleton } from './Skeletons';
import CustomDatePicker from '../atoms/CustomDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import EmptyState from '../atoms/EmptyState';
import { format } from 'date-fns';

export default function ReviewList() {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(0);
  const [date, setDate] = useState<Array<Dayjs>>([]);

  // TODO: Fix activeProfile
  const { data, refetch, isFetching } = useGetReviewsListQuery(
    {
      activeProfile: 1?.toString(),
      page: currentPage,
      startDate: !!date?.length
        ? format(date[0].toDate(), 'yyyy-MM-dd')
        : undefined,
      endDate: !!date?.length
        ? format(date[1].toDate(), 'yyyy-MM-dd')
        : undefined,
    },
    { refetchOnMountOrArgChange: true }
  );

  const refetchCallBack = () => {
    setCurrentPage(0);
  };

  return (
    <div className="space-y-6" data-testid="review-list-container">
      <div className="flex items-center justify-between" data-testid="review-list-header">
        <TitleText
          text={t('reviews.allReviews')}
          size="2xl"
          className="!text-light-button-primary !font-bold mb-4"
        />

        <CustomDatePicker
          id="date-picker"
          name="date-picker"
          isRange
          onChange={(d) => {
            setDate(d as Dayjs[]);
            setCurrentPage(0);
          }}
          maxDate={dayjs()}
          popupClassName="[&_.ant-picker-panels]:!flex-col [&_.ant-picker-panel:last-child]:!hidden [&_.ant-picker-panel:first-child_.ant-picker-header-next-btn]:!visible [&_.ant-picker-panel:first-child_.ant-picker-header-super-next-btn]:!visible"
        />
      </div>

      <div className="flex flex-col gap-4" data-testid="review-list-content">
        {isFetching ? (
          new Array(5)
            .fill(0)
            .map((e, idx) => <ReviewSkeleton key={idx + 15} />)
        ) : !!data?.content?.length ? (
          data.content.map((e) => (
            <ReviewBox
              key={e.id}
              review={e}
              refetch={refetch}
              refetchCallBack={refetchCallBack}
            />
          ))
        ) : (
          <EmptyState />
        )}
      </div>

      <div dir="ltr">
        <Pagination
          className="flex  justify-center"
          total={data?.totalElements || 0}
          defaultCurrent={currentPage + 1}
          current={currentPage + 1}
          onChange={(e) => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setCurrentPage(e - 1);
          }}
        />
      </div>
    </div>
  );
}